import type { OrganizerAccessWindow } from '../stores/settingsStore';

export const isWithinOrganizerAccessWindow = (
  window: OrganizerAccessWindow | null | undefined,
  now: number = Date.now()
) => {
  if (!window?.startAt || !window?.endAt) {
    return true;
  }
  return now >= window.startAt && now <= window.endAt;
};

export const formatOrganizerAccessWindow = (window: OrganizerAccessWindow | null | undefined) => {
  if (!window?.startAt || !window?.endAt) {
    return '';
  }
  const start = new Date(window.startAt).toLocaleString();
  const end = new Date(window.endAt).toLocaleString();
  return `${start} - ${end}`;
};

export const getOrganizerAccessErrorMessage = (window: OrganizerAccessWindow | null | undefined) => {
  if (!window?.startAt || !window?.endAt) {
    return 'Organizer access is currently restricted.';
  }
  const start = new Date(window.startAt).toLocaleString();
  const end = new Date(window.endAt).toLocaleString();
  return `Organizer access is only available between ${start} and ${end}.`;
};
